var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPmApplicationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 15.9319V14.3539C10.6581 14.2924 9.8949 14.2832 9.33054 14.2818L8.81312 14.2822C4.95811 14.3008 0 14.7939 0 18.4839C0 22.5465 6.29966 22.7028 8.77458 22.7088L9.05257 22.709C11.3045 22.709 13.987 22.5627 15.8441 21.7058C15.7683 21.643 15.6976 21.5741 15.6329 21.5H15.375C14.5407 21.5 13.7165 21.2352 13.0363 20.7304C11.9636 20.9064 10.6349 20.9947 9.05257 20.9947C4.18286 20.9947 1.71429 20.1502 1.71429 18.4839C1.71429 16.8324 4.18286 15.9959 9.05257 15.9959C9.89058 15.9959 10.6575 16.0209 11.3529 16.0708C11.3989 16.0221 11.448 15.9757 11.5 15.9319ZM14.5861 3.5796C14.3111 2.97029 13.9384 2.41421 13.488 1.93148C12.3798 0.743699 10.8016 0 9.05257 0C5.70514 0 2.98282 2.72228 2.98282 6.06514C2.97143 9.40228 5.67657 12.1257 9.016 12.136H9.05257C9.92297 12.136 10.7511 11.9519 11.5 11.6206V9.76685C10.7981 10.2332 9.95648 10.5051 9.05257 10.5051V11.3211L9.01942 10.5051C6.58285 10.496 4.60686 8.50742 4.61483 6.06857C4.61483 3.62171 6.60571 1.632 9.05257 1.632C10.1829 1.632 11.2159 2.05702 12 2.75576C12.4582 3.16406 12.8314 3.66582 13.0895 4.23086C13.5405 3.90788 14.0519 3.68847 14.5861 3.5796Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 6H15.25C14.9185 6 14.6005 6.13696 14.3661 6.38076C14.1317 6.62456 14 6.95522 14 7.3V17.7C14 18.0448 14.1317 18.3754 14.3661 18.6192C14.6005 18.863 14.9185 19 15.25 19H22.75C23.0815 19 23.3995 18.863 23.6339 18.6192C23.8683 18.3754 24 18.0448 24 17.7V10.55L19.625 6Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6V11H24",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmApplicationsIcon);
export default __webpack_public_path__ + "static/media/PmApplicationsIcon.b2b3db3a734dd272dcb099bd9f6d06a7.svg";
export { ForwardRef as ReactComponent };